import Link from 'next/link';

import { FeaturedLeaguesModule } from '@/entities/FeaturedLeaguesData';
import getPBracketsCDNURL from '@pickleballinc/ui/components/global/utils/getPBracketsCDNURL';
import clsx from 'clsx';

interface HorizontalLeaguesCardProps {
	league: FeaturedLeaguesModule;
	isHeightFitContent?: boolean;
	className?: string;
	refetch?: () => void;
}

const formatDate = (date: string | Date): string => {
	const d = typeof date === 'string' ? new Date(date) : date;
	return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const HorizontalLeaguesCard = ({ league, className = '' }: HorizontalLeaguesCardProps) => {
	// const { addToFavorites, removeFromFavorites, isAdding, isRemoving } = useFavoriteLeagueMutation();

	/* const handleFavoriteToggle = (event: React.MouseEvent) => {
		event.stopPropagation();
		event.preventDefault();

		const mutation = league.isFavourite ? removeFromFavorites : addToFavorites;

		if (isAdding || isRemoving) return;

		mutation.mutate(
			{ moduleUuid: league.uuid },
			{
				onSuccess: () => refetch && refetch()
			}
		);
	}; */

	return (
		<Link href={`/team-leagues/${league.moduleData.slug || league.moduleUuid}${league.isSeasonActive ? '/standings' : ''}`}>
			<div
				className={`hover:bg-gray-100 flex min-h-[160px] min-w-[260px] cursor-pointer overflow-hidden rounded-lg border border-gray-300 bg-white ${className} p-1`}
			>
				<div className={'relative flex h-[160px] min-w-[150px] max-w-[200px] flex-col items-center justify-center gap-2'}>
					{/* Currently, there's no example in the response of how the logo  */}
					{/* should be returned within the object. The "logos" object is empty. */}
					<img
						src={
							league.moduleData?.logo
								? getPBracketsCDNURL(`${league.moduleData?.logo.url}`, 180, 140)
								: `${process.env.NEXT_PUBLIC_IMAGE_CDN}/placeholder/pickleball_transparent_square.png`
						}
						alt="League logo"
						className={clsx('mx-auto mb-5 max-h-full w-full rounded-md', {
							'border border-gray-200': Boolean(league.moduleData?.logo)
						})}
					/>

					{league.moduleData.playerCount > 0 && (
						<div className="absolute inset-x-0 bottom-0 flex h-7 w-full items-center justify-center rounded-[5px] bg-success-800 px-2 py-1 text-sm text-white">
							{league.moduleData.playerCount} players
						</div>
					)}

					{/* Favoriting feature temporarily disabled */}

					{/* <div
						onClick={handleFavoriteToggle}
						className="absolute right-2 top-2 cursor-pointer transition-transform duration-150 hover:scale-105 active:scale-95"
					>
						<div className="rounded-md border border-gray-300 bg-white px-1 shadow-md">
							<FontAwesomeIcon
								icon={league.isFavourite ? solidHeart : regularHeart}
								className={`text-md transition-colors duration-150 ${league.isFavourite ? 'text-error-700' : 'text-gray-600'}`}
							/>
						</div>
					</div> */}
				</div>

				<div className={`flex h-full grow flex-col gap-2 p-4`}>
					{league.moduleData?.startDate && league.moduleData?.endDate ? (
						<p
							className={`text-sm text-gray-500`}
						>{`${formatDate(league.moduleData.startDate)} - ${formatDate(league.moduleData.endDate)}`}</p>
					) : (
						league.moduleData?.endDate && <p className={`text-sm text-gray-500`}>Ended on {formatDate(league.moduleData.endDate)}</p>
					)}
					<h3 className={`text-base font-medium leading-tight text-gray-800`}>{league.moduleData?.title}</h3>
					<p className={`text-sm text-gray-500`}>
						{/* {league.location.city}, */} {league.moduleData?.title}, {league.moduleData?.abbreviation}
					</p>
					{league.moduleData?.startDate && <p className={`text-sm text-gray-500`}>Start: {formatDate(league.moduleData.startDate)}</p>}
				</div>
			</div>
		</Link>
	);
};
